// 导入组件，组件必须声明 name
import AceSelectUser from "./src/main";
// 为组件添加 install 方法，用于按需引入
AceSelectUser.install = function (Vue) {
  Vue.component(AceSelectUser.name, AceSelectUser);
};
export default AceSelectUser;
